import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListChannelText = styled.span<{
  available: boolean;
  focused: boolean;
  scroll: boolean;
}>`
  animation: ${(props) =>
    props.scroll
      ? 'scroll 5s infinite linear 2s, hide 5s infinite step-end 2s'
      : ''};
  color: ${(props) => (props.available ? Colors['text'] : Colors['darkGrey'])};
  font-family: ${Fonts['regular']};
  font-size: ${(props) => (props.focused ? 42 : 30 * Screen.widthRatio)}px;
  line-height: ${60 * Screen.widthRatio}px;
  vertical-align: top;
  text-overflow: ${(props) => (props.scroll ? '' : 'ellipsis')};
  overflow: ${(props) => (props.scroll ? '' : 'hidden')};

  @keyframes hide {
    50% {
      opacity: 0;
    }
    51% {
      opacity: 1;
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    50% {
      transform: translateX(-101%);
    }
    51% {
      transform: translateX(101%);
    }
    100% {
      transform: translateX(0%);
    }
  }
`;

export default ChannelListChannelText;
